module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8ee269975ec5e64f6e18f8d757797cbd.png";